define(function(require){
 	'use strict';


// #title - наличие у модального окна шапки. Если параметр неравен "", то заголовок окна будет равняться значению данного араметра
// #title_close - true/false - наличие закрывающего "крестика" в шапке окна
// #body - html код - тело окна
// #footer - true/false - наличие футера у окна
// #footer_close - наличие у футера окна закрывающей кнопки. Если параметр неравен "", то названием кнопки будет значение данного параметра
// #footer_btn - наличие у футера окна кнопки. Если параметр неравен "", то названием кнопки будет значение данного параметра
// #footer_href - если есть кнопка в футере, то эта опция отвчает за ссылку, которая внутри кнопки. По умолчани #

// #header : {
// 	default - вызывается шаблон по умолчанию
//
// }


 	var Marionette = require('marionette');

 	return Backbone.Model.extend({
 		defaults : {
 			title : "По умолчанию",
 			title_close : true ,
 			show_footer : true ,
 			show_header : true
 		}
 	});

 });
